// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"CustomNavStyles_sidebarContainer__xI8BD","sidebar":"CustomNavStyles_sidebar__ZMu9w"};